import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HeaderService } from './../header/header.service';
import { AuthenticationService, HttpClientService } from 'lib/ng2-sapmp/src/providers';
import { HttpResponse } from '@angular/common/http';


declare var PREMIER_LOGIN_URL: any;
declare var MYATT_LOGIN_URL: any;
declare var ENV_PORTAL;

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  condensedFlag = false;
  currentYear: any;
  triggerUrl: any;
  triggerUrlForMyAtt: any;
  sapmp: any;
  pageContent: any;
  fnabc: any;
  firstNetAppUrl: any;
  firstNetLocalControl: any;
  pageContentkey: any;

  constructor(private headerService: HeaderService,
    private httpClientService: HttpClientService,
    private authenticationService: AuthenticationService,
  ) {

    // this.pageContentkey = (ENV_PORTAL === 'sapmp') ? "footerabc" : "footerfnabc";
    if(ENV_PORTAL !== "dmpadmin"){
      this.headerService.pageContent(ENV_PORTAL).subscribe((res: HttpResponse<any>) => {
        this.pageContent = res[ENV_PORTAL].footer;
        this.setRKey();
        if (ENV_PORTAL === 'sapmp') {
          this.pageContent.footerNav.firstCol[3].href = this.triggerUrl;
          this.pageContent.footerNav.firstCol[4].href = this.triggerUrlForMyAtt;
        }else if (ENV_PORTAL === 'myatt') {
          this.pageContent.footerNav.firstCol[3].href = this.triggerUrl;
          this.pageContent.footerNav.firstCol[4].href = this.triggerUrlForMyAtt;
        }
      });
    }
  }

  ngOnInit() {
    this.currentYear = this.httpClientService.getCurrentYear();
    this.headerService.getCondensedFooterStatus().subscribe(
      (status: boolean) => {
        this.condensedFlag = status;
      }
    );
  }

  setCallingPage(callingPageUrl) {
    sessionStorage.setItem('callingPageName', callingPageUrl);
  }

  commonFunction(funcName, paramter) {
    if (funcName == "setCallingPage") {
      this.setCallingPage(paramter);
    }
  }

  setRKey() {
    this.triggerUrl = PREMIER_LOGIN_URL;
    this.triggerUrlForMyAtt = MYATT_LOGIN_URL ;
  }

}
